import { Component, Inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';

import { TSourceItem } from '@core/interfaces/TSourceItem';

import { PdfViewerComponent } from '../veeva-annotations-modal/pdf-viewer/pdf-viewer.component';

@Component({
    selector: 'app-simple-file-preview-modal',
    templateUrl: './simple-file-preview-modal.component.html',
    styleUrls: ['./simple-file-preview-modal.component.scss'],
    standalone: true,
    imports: [PdfViewerComponent, MatIcon, MatButton]
})
export class SimpleFilePreviewModalComponent {
  constructor(
    private dialogRef: MatDialogRef<SimpleFilePreviewModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { source: TSourceItem }
  ) {}

  close(): void {
    this.dialogRef.close();
  }
}
